<template>
	<div class="wp-input">
		<label for="">{{ label }}</label>
		<el-input class="input-form" v-model="dd">
			<!-- <el-select v-model="select" slot="prepend" placeholder="请选择">
				<el-option label="餐厅名" value="1"></el-option>
				<el-option label="订单号" value="2"></el-option>
				<el-option label="用户电话" value="3"></el-option>
			</el-select> -->
			<slot></slot>
		</el-input>
	</div>
</template>

<script>
	export default {
		name: "WpInput",
		props: {
			label: String,
		},
		data() {
			return { dd: "" };
		},
	};
</script>

<style lang="less">
	.input-form {
		input {
			border-radius: 100px;
			height: 50px;
		}

		// .el-input-group__prepend {
		// 	border-radius: 100px;
		// }
	}
</style>


// WEBPACK FOOTER //
// src/components/WpInput.vue